import { render, staticRenderFns } from "./ServicePolicy.vue?vue&type=template&id=c013c210"
import script from "./ServicePolicy.vue?vue&type=script&lang=js"
export * from "./ServicePolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports